import * as React from "react";

function SvgMoonIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.984 511.984" width="1em" height="1em" {...props}>
      <path
        d="M277.308 149.449h-42.632c-5.891 0-10.672-4.773-10.672-10.664s4.781-10.664 10.672-10.664h42.632c5.905 0 10.687 4.773 10.687 10.664s-4.781 10.664-10.687 10.664z"
        fill="#f6bb42"
      />
      <path
        d="M405.273 362.707c-141.332 0-255.906-114.582-255.906-255.913 0-31.765 5.797-62.186 16.374-90.255C68.947 53.03.09 146.512.09 256.078c0 141.331 114.575 255.906 255.914 255.906 109.551 0 203.048-68.857 239.517-165.651-28.063 10.578-58.467 16.374-90.248 16.374z"
        fill="#ffce54"
      />
      <path
        d="M277.308 490.656c-141.316 0-255.89-114.574-255.89-255.906 0-65.217 24.405-124.738 64.561-169.924C33.292 111.7.09 180.002.09 256.078c0 141.331 114.575 255.906 255.914 255.906 76.053 0 144.363-33.203 191.235-85.903-45.184 40.184-104.715 64.575-169.931 64.575z"
        fill="#f6bb42"
      />
      <path
        d="M383.961 138.785c0 5.891-4.781 10.664-10.688 10.664-5.875 0-10.656-4.773-10.656-10.664s4.781-10.664 10.656-10.664c5.907 0 10.688 4.773 10.688 10.664z"
        fill="#4a89dc"
      />
      <path
        d="M330.65 245.414c0 5.883-4.781 10.664-10.687 10.664-5.875 0-10.656-4.781-10.656-10.664 0-5.891 4.781-10.664 10.656-10.664 5.906 0 10.687 4.773 10.687 10.664z"
        fill="#48cfad"
      />
      <path
        d="M511.894 117.285c0 5.891-4.781 10.664-10.656 10.664-5.874 0-10.655-4.773-10.655-10.664 0-5.89 4.781-10.663 10.655-10.663 5.875 0 10.656 4.773 10.656 10.663z"
        fill="#ed5564"
      />
      <path
        d="M319.964 10.656c0 5.891-4.75 10.664-10.656 10.664-5.875 0-10.656-4.773-10.656-10.664C298.652 4.773 303.433 0 309.308 0a10.644 10.644 0 0110.656 10.656z"
        fill="#ac92eb"
      />
      <path
        d="M256.004 96.13c-5.891 0-10.672 4.781-10.672 10.664v63.982c0 5.883 4.781 10.656 10.672 10.656 5.875 0 10.656-4.773 10.656-10.656v-63.982c0-5.883-4.781-10.664-10.656-10.664z"
        fill="#ffce54"
      />
      <path
        d="M437.272 213.423c-5.906 0-10.656 4.773-10.656 10.664v63.967c0 5.906 4.75 10.672 10.656 10.672 5.874 0 10.654-4.766 10.654-10.672v-63.967c.001-5.89-4.78-10.664-10.654-10.664z"
        fill="#f6bb42"
      />
      <path
        d="M458.583 266.734H415.93c-5.875 0-10.656-4.773-10.656-10.656 0-5.891 4.781-10.664 10.656-10.664h42.653c5.906 0 10.656 4.773 10.656 10.664 0 5.883-4.75 10.656-10.656 10.656z"
        fill="#ffce54"
      />
    </svg>
  );
}

export default SvgMoonIcon;
